import React from 'react';
import { getRouterAdapter } from '../utils';

export const useQueryParams = () => {
  const { search } = getRouterAdapter().useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
